import { z } from 'zod'

export const preferenceFormSchema = z.object({
  educationalLevels: z.array(
    z.enum(['PRIMARY', 'MIDDLE', 'HIGH', 'BACHELOR', 'MASTER', 'PHD', 'ANY'])
  ),
  regions: z.array(
    z.enum([
      'NORTHERN',
      'NORTH_EASTERN',
      'CENTRAL',
      'EASTERN',
      'WESTERN',
      'SOUTHERN',
      'BANGKOK_METROPOLITAN',
    ])
  ),
  memberTypes: z.array(z.enum(['SINGLE', 'TEAM'])),
  certificate: z.boolean().optional(),
  companyPartnership: z.boolean().optional(),
  internship: z.boolean().optional(),
  trophy: z.boolean().optional(),
  publishWork: z.boolean().optional(),
  isBooleanOptionActive: z.boolean().optional(),
  isPrizeSliderActive: z.boolean().optional(),
  prizeNumberMin: z.number().min(0).optional(),
  prizeNumberMax: z.number().min(0).optional(),
  teamNumberMin: z.number().min(1).optional(),
  teamNumberMax: z.number().min(1).optional(),
  openDate: z.date().optional(),
  closingDate: z.date().optional(),
  sortBy: z
    .enum(['title_th', 'created_timestamp', 'open_date', 'closing_date'])
    .optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  categories: z.array(z.number()),
  isViewActiveContests: z.boolean().optional(),
})

export type PreferenceFormSchema = z.infer<typeof preferenceFormSchema>
